import { ethers, utils } from 'ethers';
import { useEffect, useState } from 'react';
import SyncLoader from 'react-spinners/SyncLoader';
import { useHttp } from 'src/hooks';
import { getArenaBalanceOf } from 'src/utilities/looty';
import { useAccount } from 'wagmi';

interface Props {
  activeProject: any;
}

const environment = process.env.REACT_APP_ENVIRONMENT;

function ArenaRewardCard({ activeProject }: Props) {
  const { address } = useAccount();
  const [detailOpen, setDetailOpen] = useState(false);
  const [balanceOfArenaToken, setBalanceOfArenaToken] = useState<string>('0');
  const [loading, setLoading] = useState<boolean>(true);
  const { sendRequest } = useHttp();
  const [collection, setCollection] = useState<any>();

  useEffect(() => {
    const fetchBalance = async () => {

      if(activeProject?.slug !== 'arena'){
        return;
      }

      console.log('aaaaaaaaaaaaaaaaaaaaaaaa')
      const phase1Config = activeProject?.stages?.filter((stage: any) => stage.order === 1)[0]
        .metadata[environment];
      try {
        setLoading(true);
        const provider = new ethers.providers.JsonRpcProvider(activeProject?.network.RPCUrl);
        // const provider = new ethers.providers.Web3Provider(window.ethereum as any);
        const contractAddress = phase1Config.LOOTY_ARENA_TOKEN.address || '';
        const balance = await getArenaBalanceOf(
          provider,
          contractAddress,
          address,
          phase1Config?.LOOTY_ARENA_TOKEN?.abi,
        );
        setLoading(false);
        setBalanceOfArenaToken(Number(balance).toString());
      } catch (error) {
        console.error('Error fetching balance:', error);
      } finally {
        setLoading(false);
      }
    };
    if (activeProject?.slug === 'arena') fetchBalance();
  }, []);

  const getCollectionDetailById = () => {
    sendRequest(
      {
        url: `collections/${activeProject?.id}`,
        method: 'GET',
      },
      (data: any) => {
        setCollection(data);
      },
    );
  };

  useEffect(() => {
    getCollectionDetailById();
  }, [activeProject?.id]);

  const toggleDetail = () => {
    setDetailOpen(!detailOpen);
  };

  return (
    <>
      {loading ? (
        <div className="border-2 border-grayscale-700 p-5 rounded-md flex items-center justify-center text-[32px] font-joystix text-grayscale-700 h-[620px] uppercase col-span-full">
          <SyncLoader color="#B73FFF" size={10} />
        </div>

      ) : Number(balanceOfArenaToken) > 0 ? (
        <div className="p-5 rounded-md bg-grayscale-800 space-y-[17px]">
          <img src="/assets/images/arena-reward-card.png" alt="" className="w-full" />

          <div className="bg-grayscale-900 rounded-md py-3">
            <h5 className="text-brand-primary-light text-lg font-normal text-center">
              {loading ? 'Loading...' : `${balanceOfArenaToken} Arena`}
            </h5>
          </div>
        </div>
      ) : (
        <div className="border-2 border-grayscale-700 p-5 rounded-md flex items-center justify-center text-[32px] font-joystix text-grayscale-700 h-[620px] uppercase col-span-full">
          No rewards found
        </div>
      )}

      {/* {detailOpen && (
        <div className="w-full h-fit">
          <div className="text-lg text-grayscale-300 font-bold flex items-center gap-[17px] mb-8">
            <div className="cursor-pointer" onClick={toggleDetail}>
              The Arena rewards
            </div>

            <IconSvg icon="arrowRightM" className="text-grayscale-300" />

            <div>3ttWr...4rfwe</div>
          </div>

          <div className="flex items-center justify-between mb-10">
            <div className="flex items-center gap-6">
              <div className="w-[109px] h-[109px] rounded-md">
                <img src="/assets/images/arena-logo.png" alt="" className="w-full h-full" />
              </div>

              <div className="space-y-1">
                <div className="text-sm leading-none text-grayscale-500">UNLOCKED</div>

                <h4 className="uppercase text-brand-primary-light">0 the arena</h4>

                <div className="flex gap-1 text-grayscale-200">
                  <div>37.500 The Arena</div>

                  <div>
                    (<span className="underline text-brand-primary">ty2E1...uue8W</span>)
                  </div>
                </div>
              </div>
            </div>

            <Button size="m" type="disabled">
              Claim
            </Button>
          </div>

          <div className="flex justify-between gap-4 mb-10">
            <img src="/assets/images/profile-graph.png" alt="" />

            <div className="space-y-10 w-[30%]">
              <div className="space-y-2">
                <div className="text-xs text-grayscale-400">Type</div>

                <div className="text-[24px] text-grayscale-100">Vesting</div>
              </div>

              <div className="space-y-2">
                <div className="text-xs text-grayscale-400">Start time</div>

                <div className="text-[24px] text-grayscale-100">
                  November 15 2024, <span className="text-grayscale-500">1:34pm</span>
                </div>
              </div>

              <div className="space-y-2">
                <div className="text-xs text-grayscale-400">End time</div>

                <div className="text-[24px] text-grayscale-100">
                  December 15 2024, <span className="text-grayscale-500">1:34pm</span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full mb-10 border-b border-grayscale-700"></div>

          <div className="grid gap-10 grid-cols-[repeat(auto-fit,minmax(341px,1fr))]">
            <div className="space-y-2">
              <div className="text-xs text-grayscale-400">Claimed</div>

              <div className="text-[24px] text-grayscale-100 flex items-center gap-2">
                <img
                  src="/assets/images/arena-logo.png"
                  alt=""
                  className="w-6 h-6 bg-center rounded-full"
                />

                <span>0 ARENA ($0)</span>
              </div>
            </div>

            <div className="space-y-2">
              <div className="text-xs text-grayscale-400">Unlocked</div>

              <div className="text-[24px] text-grayscale-100 flex items-center gap-2">
                <img
                  src="/assets/images/arena-logo.png"
                  alt=""
                  className="w-6 h-6 bg-center rounded-full"
                />

                <span>0 ARENA ($0)</span>
              </div>
            </div>

            <div className="space-y-2">
              <div className="text-xs text-grayscale-400">Total</div>

              <div className="text-[24px] text-grayscale-100 flex items-center gap-2">
                <img
                  src="/assets/images/arena-logo.png"
                  alt=""
                  className="w-6 h-6 bg-center rounded-full"
                />

                <div className="text-[24px] text-grayscale-100">
                  37.500 ARENA <span className="text-grayscale-500">($261.49)</span>
                </div>
              </div>
            </div>

            <div className="space-y-2">
              <div className="text-xs text-grayscale-400">Unlock rate</div>

              <div className="text-[24px] text-grayscale-100">Bi-monthly</div>
            </div>

            <div className="space-y-2">
              <div className="text-xs text-grayscale-400">Unlock per bi-monthly</div>

              <div className="text-[24px] text-grayscale-100 flex items-center gap-2">
                <img
                  src="/assets/images/arena-logo.png"
                  alt=""
                  className="w-6 h-6 bg-center rounded-full"
                />

                <div className="text-[24px] text-grayscale-100">
                  9375 ARENA <span className="text-grayscale-500">($65.37)</span>
                </div>
              </div>
            </div>

            <div className="space-y-2">
              <div className="text-xs text-grayscale-400">Next unlock</div>

              <div className="text-[24px] text-grayscale-100 flex items-center gap-2">
                <img
                  src="/assets/images/arena-logo.png"
                  alt=""
                  className="w-6 h-6 bg-center rounded-full"
                />

                <div className="text-[24px] text-grayscale-100">
                  November 30 2024, <span className="text-grayscale-500">1:34pm</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
}

export default ArenaRewardCard;
